import React from 'react';
import PropTypes from 'prop-types';
import View from "react-native-web/dist/exports/View";
import StyleSheet from "react-native-web/dist/exports/StyleSheet";
import { selectSystemProps, withLinkRouter, htmlAttrs } from '../utils';
import PressableItem from './PressableItem';
import { useThemeTokensCallback } from '../ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const [selectProps, selectedSystemPropTypes] = selectSystemProps([htmlAttrs]);
const styles = StyleSheet.create({
  itemContainer: {
    display: 'flex',
    margin: 0
  },
  childContainer: {
    paddingLeft: 16
  },
  nestedChildContainer: {
    paddingLeft: 24
  }
});
const ListboxItem = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    href,
    label,
    isChild = false,
    nestedChild,
    onBlur,
    nextItemRef,
    prevItemRef,
    tokens,
    variant = {},
    LinkRouter,
    linkRouterProps,
    id,
    onPress = () => {},
    ...rest
  } = _ref;
  const selectedProps = selectProps({
    href,
    ...rest
  });
  const getTokens = useThemeTokensCallback('Listbox', tokens, variant, {
    isChild
  });
  return /*#__PURE__*/_jsx(View, {
    style: [styles.itemContainer, isChild && styles.childContainer, nestedChild && styles.nestedChildContainer],
    role: "option",
    children: /*#__PURE__*/_jsx(PressableItem, {
      href: href,
      isChild: isChild,
      onPress: onPress,
      onBlur: onBlur,
      nextItemRef: nextItemRef,
      prevItemRef: prevItemRef,
      ref: ref,
      tokens: getTokens,
      selectedProps: selectedProps,
      id: id,
      children: label
    })
  });
});
ListboxItem.displayName = 'ListboxItem';
ListboxItem.propTypes = {
  ...selectedSystemPropTypes,
  ...withLinkRouter.propTypes,
  href: PropTypes.string,
  isChild: PropTypes.bool,
  label: PropTypes.node.isRequired,
  nextItemRef: PropTypes.object,
  prevItemRef: PropTypes.object,
  onPress: PropTypes.func,
  nestedChild: PropTypes.bool
};
export default withLinkRouter(ListboxItem);